import { composeFetch, composeParser } from '@library/http'
import { getAuthUserId } from '@library/auth'
import {
  addPath,
  composeRequest,
  setMethod,
  setQueryParams,
  setServiceUrl,
} from '@library/http/requests'
import { RecipeQueryInput, RecipeQueryResponse } from './interfaces/recipe'

const getResponseParser = <T>() =>
  composeParser<Response, Promise<T>>(async (response: Response) => {
    if (!response.ok) {
      const responseMsg = await response.text()
      throw new Error(`service responded with ${response.status}: ${responseMsg}`)
    }

    return await response.json()
  })

export const recipeFetcher = composeFetch(
  composeRequest<RecipeQueryInput>(
    setServiceUrl('menuexperience', 1),
    addPath((input) => `recipes/${input.recipeId}`),
    setMethod('GET'),
    setQueryParams(({ numPortions, menuId, collectionId, deliveryDate, customisationTypes }) => {
      const userId = getAuthUserId()
      return {
        numPortions: numPortions.toString(),
        menuId,
        deliveryDate,
        ...(customisationTypes && { customisationTypes }),
        ...(userId && { userId }),
        ...(collectionId && { collectionId }),
      }
    }),
  ),
  getResponseParser<RecipeQueryResponse>(),
)
